module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "admin-page"
  }, [_vm._v("Histórico de Entregas")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "box-aside line-top smart-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-aside-body box-aside-filters"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("EMPRESA")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    ref: "slEmpresa",
    staticClass: "form-control select2 filter-select2",
    staticStyle: {
      "z-index": "1000",
      "width": "100%!important",
      "max-width": "100%"
    },
    attrs: {
      "multiple": "",
      "data-select2-container": "big-text"
    }
  }, _vm._l((_vm.empresas), function(empresa) {
    return _c('option', {
      key: empresa._id,
      domProps: {
        "value": empresa._id
      }
    }, [_vm._v(_vm._s(empresa.empresa.razonSocial) + " - " + _vm._s(empresa.denominacion))])
  })), _vm._v(" "), _c('a', {
    staticClass: "disable-filter",
    class: {
      show: _vm.filtros.empresas.length > 0
    },
    on: {
      "click": _vm.quitarFiltrosEmpresa
    }
  }, [_vm._v("Quitar filtro empresa")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("EMPLEADO")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    ref: "slUsuario",
    staticClass: "form-control select2 filter-select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "data-select2-container": "big-text"
    }
  }, _vm._l((_vm.usuariosDistinct), function(usuario) {
    return _c('option', {
      key: usuario._id,
      domProps: {
        "value": usuario._id
      }
    }, [_vm._v(_vm._s(usuario.displayName))])
  })), _vm._v(" "), _c('a', {
    staticClass: "disable-filter",
    class: {
      show: _vm.filtros.empleados.length > 0
    },
    on: {
      "click": _vm.quitarFiltrosEmpleado
    }
  }, [_vm._v("Quitar filtro empleado")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("DESDE")]), _vm._v(" "), _c('date-picker', {
    ref: "pickerDesde",
    attrs: {
      "max-date": new Date()
    },
    model: {
      value: (_vm.filtros.desde),
      callback: function($$v) {
        _vm.filtros.desde = $$v
      },
      expression: "filtros.desde"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "disable-filter",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Quitar filtro fecha")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("HASTA")]), _vm._v(" "), _c('date-picker', {
    ref: "pickerHasta",
    attrs: {
      "max-date": new Date()
    },
    model: {
      value: (_vm.filtros.hasta),
      callback: function($$v) {
        _vm.filtros.hasta = $$v
      },
      expression: "filtros.hasta"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "disable-filter",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Quitar filtro fecha")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("ESTADO")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.estado),
      expression: "filtros.estado"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtros.estado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', [_vm._v("Recibido")]), _vm._v(" "), _c('option', [_vm._v("Cocina")]), _vm._v(" "), _c('option', [_vm._v("Empaquetado")]), _vm._v(" "), _c('option', [_vm._v("Despachado")]), _vm._v(" "), _c('option', [_vm._v("Entregado")]), _vm._v(" "), _c('option', [_vm._v("Cancelado")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa fa-angle-down"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear-sm"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-aside line-top smart-form"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-aside-body resume stats"
  }, [_c('div', {
    staticClass: "stats-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticClass: "stats-number process"
  }, [_vm._v(_vm._s(_vm.contadores['Recibido']))])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "stats-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticClass: "stats-number payment-pending"
  }, [_vm._v(_vm._s(_vm.contadores['Cocina']))])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "stats-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticClass: "stats-number oncourse"
  }, [_vm._v(_vm._s(_vm.contadores['Empaquetado']))])]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "stats-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticClass: "stats-number payment-closed"
  }, [_vm._v(_vm._s(_vm.contadores['Despachado']))])]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "stats-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticClass: "stats-number pending"
  }, [_vm._v(_vm._s(_vm.contadores['Cancelado']))])]), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-aside-body resume-total"
  }, [_c('h3', {
    staticClass: "total-number"
  }, [_vm._v(_vm._s(_vm._f("formatMoneda")(_vm.contadores['Monto'])))]), _vm._v(" "), _c('span', {
    staticClass: "total-label"
  }, [_vm._v("Total de los días filtrados")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear-sm"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-9"
  }, [_c('div', {
    staticClass: "box-style line-top smart-form"
  }, [_c('div', {
    staticClass: "box-header-lg"
  }, [_c('h1', {
    staticClass: "filter-breadcrumb"
  }, [_c('span', {
    staticClass: "semibold"
  }, [_vm._v("FILTROS")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v(" "), (_vm.filtros.desde) ? _c('span', [_vm._v(" del "), _c('span', {
    staticClass: "regular"
  }, [_vm._v(_vm._s(_vm.moment(_vm.filtros.desde).format("DD/MM/YYYY")))])]) : _vm._e(), _vm._v(" "), (_vm.filtros.hasta) ? _c('span', [_vm._v(" al "), _c('span', {
    staticClass: "regular"
  }, [_vm._v(_vm._s(_vm.moment(_vm.filtros.hasta).format("DD/MM/YYYY")))])]) : _vm._e(), _vm._v(" "), (_vm.filtros.hasta || _vm.filtros.desde) ? _c('span', [_vm._v("|")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-header-aside"
  }, [(_vm.filtros.desde || _vm.filtros.hasta || _vm.filtros.empresas.length > 0 || _vm.filtros.empleados.length > 0 || _vm.filtros.estado) ? _c('a', {
    staticClass: "quit-filter",
    on: {
      "click": function($event) {
        _vm.limpiarFiltros()
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  }), _vm._v(" Quitar filtros")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-header form smart-form"
  }, [_c('div', {
    staticClass: "form-group col-hactions"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-action"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-outline-grey-green",
    on: {
      "click": function($event) {
        _vm.exportXls()
      }
    }
  }, [_vm._v("\n                        EXCEL\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-outline-grey-green",
    on: {
      "click": function($event) {
        _vm.exportPdf()
      }
    }
  }, [_vm._v("\n                         PDF\n                      ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-group smart-accordion-default",
    attrs: {
      "id": "accordion"
    }
  }, _vm._l((_vm.entregasAgrupadas), function(entregasFecha, idx, a) {
    return _c('div', {
      key: entregasFecha,
      staticClass: "panel panel-time"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('div', {
      staticClass: "panel-title box-header"
    }, [_c('a', {
      attrs: {
        "data-toggle": "collapse",
        "href": '#panel' + a
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-angle-down pull-right"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-lg fa-angle-up pull-right"
    }), _vm._v(" "), _c('h2', [_c('b', [_vm._v(_vm._s(idx))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse in",
      attrs: {
        "id": 'panel' + a
      }
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "table-container"
    }, [_c('table', {
      staticClass: "table table-hover table-stripped table-no-first-pad table-manager-time"
    }, [_vm._m(8, true), _vm._v(" "), _c('tbody', _vm._l((entregasFecha), function(entrega) {
      return _c('tr', {
        key: entrega._id
      }, [_c('td', [_vm._v(_vm._s(entrega.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.horaEntrega) + "hs")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.usuario.displayName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.sucursal.empresa.razonSocial) + "-" + _vm._s(entrega.sucursal.denominacion))]), _vm._v(" "), _c('td', [_c('span', {
        staticClass: "truncate"
      }, [_vm._v(_vm._s(entrega.platosSerialized))])]), _vm._v(" "), _c('td', {
        staticClass: "td-status"
      }, [_vm._v("\n                              " + _vm._s(entrega.estado) + "\n                            ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('a', {
        staticClass: "btn btn-outline btn-xsw pull-right",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.abrirComanda(entrega)
          }
        }
      }, [_vm._v("DETALLE")])])])
    }))])])])])])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade detalle-pedido",
    attrs: {
      "id": "detalle-pedido",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [(_vm.entregaComanda) ? _c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(9), _vm._v(" "), _c('h2', [_vm._v("Comanda #" + _vm._s(_vm.entregaComanda.numero))]), _vm._v(" "), _c('p', {
    staticClass: "size-16"
  }, [_vm._v("\n        Fecha y hora: "), _c('span', {
    staticClass: "semibold"
  }, [_vm._v(_vm._s(_vm._f("fechaComanda")(_vm.entregaComanda.fechaEntrega)))]), _c('br'), _vm._v("\n        Empresa: "), _c('span', {
    staticClass: "semibold"
  }, [_vm._v(_vm._s(_vm.entregaComanda.sucursal.empresa.razonSocial) + " - " + _vm._s(_vm.entregaComanda.sucursal.denominacion))]), _c('br'), _vm._v("\n        Empleado: "), _c('span', {
    staticClass: "semibold"
  }, [_vm._v(_vm._s(_vm.entregaComanda.usuario.displayName))]), _c('br'), _vm._v(" "), (_vm.entregaComanda.usuario.other || _vm.entregaComanda.usuario.alergic || _vm.entregaComanda.usuario.vegan || _vm.entregaComanda.usuario.vegetarian) ? _c('span', {
    staticClass: "deliveryModalRestrictions"
  }, [_c('h4', [_vm._v("TIENE RESTRICCIONES ALIMENTICIAS")]), _vm._v(" "), (_vm.entregaComanda.usuario.vegan) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "icon-vegan"
  }), _vm._v(" Vegano")]) : _vm._e(), _vm._v(" "), (_vm.entregaComanda.usuario.vegetarian) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "icon-vegetarian"
  }), _vm._v(" Vegetariano")]) : _vm._e(), _vm._v(" "), (_vm.entregaComanda.usuario.celiac) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "icon-celiac"
  }), _vm._v(" Sin gluten")]) : _vm._e(), _vm._v(" "), (_vm.entregaComanda.usuario.other) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "icon-menu-config"
  }), _vm._v(" Otros")]) : _vm._e(), _vm._v(" "), (_vm.entregaComanda.usuario.alergic) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "icon-spice"
  }), _vm._v(" Alérgico")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.entregaComanda.usuario.other || _vm.entregaComanda.usuario.alergic) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.entregaComanda.usuario.restrictions) + "\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "order-list"
  }, _vm._l((_vm.entregaComanda.platos), function(plato) {
    return _c('li', {
      key: plato._id
    }, [_c('span', [_vm._v(_vm._s(plato.cantidad) + "x")]), _vm._v(" " + _vm._s(plato.plato.nombre))])
  }))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "contenedorExport",
    staticClass: "hidden"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header-lg"
  }, [_c('i', {
    staticClass: "icon-filter"
  }), _c('h1', [_vm._v(" FILTROS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header-lg"
  }, [_c('i', {
    staticClass: "icon-stats"
  }), _c('h1', [_vm._v(" RESUMEN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('span', {
    staticClass: "stats-label"
  }, [_vm._v("Recibidos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('span', {
    staticClass: "stats-label"
  }, [_vm._v("En Cocina")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('span', {
    staticClass: "stats-label"
  }, [_vm._v("Empaquetados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('span', {
    staticClass: "stats-label"
  }, [_vm._v("Despachados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('span', {
    staticClass: "stats-label"
  }, [_vm._v("Cancelados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-lg"
  }, [_c('i', {
    staticClass: "icon-export"
  }), _vm._v(" Descargar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nro.")]), _vm._v(" "), _c('th', [_vm._v("Hora")]), _vm._v(" "), _c('th', [_vm._v("Usuario")]), _vm._v(" "), _c('th', [_vm._v("Empresa")]), _vm._v(" "), _c('th', [_vm._v("Menú")]), _vm._v(" "), _c('th', [_vm._v("Estado")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10daf33c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Restaurante/HistoricoEntregas.vue
// module id = 1109
// module chunks = 5